export default __webpack_public_path__ + "static/feature_04-d08b5ca414cb622336e863961395fbf6.png";